import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { StoreItemsExposeGroup } from '../enum';
export class UpdateShowOrderResponseErrorDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'Error name', example: 'EntityNotFound' }),
    Expose({ groups: [StoreItemsExposeGroup.READ] }),
    __metadata("design:type", String)
], UpdateShowOrderResponseErrorDto.prototype, "name", void 0);
__decorate([
    ApiProperty({ type: () => String, description: 'Error descriptions', example: 'Could not find any entity of type' }),
    Expose({ groups: [StoreItemsExposeGroup.READ] }),
    __metadata("design:type", String)
], UpdateShowOrderResponseErrorDto.prototype, "message", void 0);
//# sourceMappingURL=UpdateShowOrderResponseErrorDto.js.map